// Botón "Agregar" del upsell del carrito lateral (snippets/cart-upsell.liquid).
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-upsell-add]');
  if (!btn) return;
  e.preventDefault();
  btn.disabled = true;
  btn.textContent = '...';
  try {
    const res = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.upsellAdd), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }),
    });
    const data = await res.json();
    const drawer = document.querySelector('cart-drawer');
    if (res.ok && drawer && data.sections) drawer.renderContents(data);
    else window.location.href = '/cart';
  } catch (err) {
    window.location.href = '/cart';
  }
});
